import React, { useEffect, useState } from 'react';
import createApolloClient from '../../api';
import getNoWinNoFeePage from '../../api/queries/noWinNoFeePage/getNoWinNoFeePage';
import sanitizeHTML from '../../utils/sanitiseHTML';
import NoWinNoFeeCalculator from '../NoWinNoFeeCalculator';
import Reviews from '../Reviews';

const NoWinNoFee = () => {
  const client = createApolloClient();
  const [noWinPageData, setNoWinPageData] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await client.query(getNoWinNoFeePage());
      const { acfOptionsNowinnofeepage } = data;
      const { nowinnofeepage } = acfOptionsNowinnofeepage;
      setNoWinPageData(nowinnofeepage);
      console.log('nowinnofeepage', nowinnofeepage);
    })();
  }, []);

  return (
        <div className="no-win-no-fee">
          <section className="no-win-no-fee-banner">
            <div
              className="no-win-no-fee-banner-image desktop"
              data-bg={noWinPageData?.banner?.bannerImageDesktop?.sourceUrl}
              style={{backgroundImage: `url(${noWinPageData?.banner?.bannerImageDesktop?.sourceUrl})`}}
            >
              <div className="no-win-no-fee-banner__container">
                <h2 className="no-win-no-fee-banner__container__title">{noWinPageData?.banner?.bannerTitle}</h2>
                <p className="subtitle_1">{noWinPageData?.banner?.bannerDescription}</p>
              </div>
            </div>
            <div
              className="no-win-no-fee-banner-image mobile"
              data-bg={noWinPageData?.banner?.bannerImageDesktop?.sourceUrl}
              style={{backgroundImage: `url(${noWinPageData?.banner?.bannerImageDesktop?.sourceUrl})`}}
            >
              <div className="no-win-no-fee-banner__container">
                <h2 className="no-win-no-fee-banner__container__title">{noWinPageData?.banner?.bannerTitle}</h2>
                <p className="subtitle_1">{noWinPageData?.banner?.bannerDescription}</p>
              </div>
            </div>
          </section>
          <section className="no-win-no-fee__eligiblity" id="assessment">
            <div className="no-win-no-fee__eligiblity__container">
              <div className="no-win-no-fee__eligiblity__container__inner">
                <div>
                  <h3>{noWinPageData?.areYouEligibleSection?.title}</h3>
                  <img src={noWinPageData?.areYouEligibleSection?.image?.sourceUrl} width="100%" height="auto" />
                  <div
                    className="subtitle_1"
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(noWinPageData?.areYouEligibleSection?.description),
                    }}
                  />
                </div>
                <div className="sidebar__cdf">
                  <NoWinNoFeeCalculator />
                </div>
              </div>
            </div>
          </section>
          <section className="no-win-no-fee__explanation">
            <div
              className="subtitle_1"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(noWinPageData?.whatIsNoWinNoFee) }}
            />
          </section>
          <section className="no-win-no-fee__more-explanation">
            <div
              className="subtitle_1"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(noWinPageData?.understandingNoWinNoFee) }}
            />
          </section>
          <section className="no-win-no-fee__getstarted">
            <div className="no-win-no-fee__getstarted__link">
              <img src={noWinPageData?.getStartedSection?.image?.sourceUrl} width="100%" height="auto" />
              <div
                className="subtitle_1"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(noWinPageData?.getStartedSection?.contentWithLink),
                }}
              />
            </div>
          </section>
          <section className="no-win-no-fee__more-faq">
            <div className="subtitle_1" dangerouslySetInnerHTML={{ __html: sanitizeHTML(noWinPageData?.faq) }} />
          </section>
          <section className="homepage__reviews">
            <h2>{noWinPageData?.reviewSection?.title}</h2>
            <p>{noWinPageData?.reviewSection?.description}</p>
            <Reviews>
              <h3>
                Rated 4.8 Stars in Over 1,000 <a href="/testimonials">Reviews</a>
              </h3>
              <p className="subtitle_1">
                You can rest assured that, because we represent individuals only, there is no{' '}
                <span>conflict of interest</span>
              </p>
            </Reviews>
            <section className="homepage__awards">
              <h3>{noWinPageData?.awardSection?.title}</h3>
              <div className="homepage__awards__desktop">
                <div className="homepage__awards__desktop__left">
                  <img
                    src={noWinPageData?.awardSection?.leftImage?.sourceUrl}
                    alt="award-image-left"
                    width="259"
                    height="136"
                  />
                  <p className="subtitle_1">{noWinPageData?.awardSection?.leftImageDescription}</p>
                </div>
                <div className="homepage__awards__desktop__right">
                  <img
                    src={noWinPageData?.awardSection?.rightImage?.sourceUrl}
                    alt="award-image-right"
                    width="259"
                    height="98"
                  />
                  <p className="subtitle_1">{noWinPageData?.anoWinPageData?.wardSection?.rightImageDescription}</p>
                </div>
              </div>
              <div className="homepage__awards__mobile">
                <div className="homepage__awards__mobile__left">
                  <img
                    src={noWinPageData?.awardSection?.rightImage?.sourceUrl}
                    alt="award-image-right"
                    width="218"
                    height="81"
                  />
                  <p className="subtitle_1">{noWinPageData?.awardSection?.rightImageDescription}</p>
                </div>
                <div className="homepage__awards__mobile__right">
                  <img
                    src={noWinPageData?.awardSection?.leftImage?.sourceUrl}
                    alt="award-image-left"
                    width="218"
                    height="114"
                  />
                  <p className="subtitle_1">{noWinPageData?.awardSection?.leftImageDescription}</p>
                </div>
              </div>
            </section>
            <div
              className="homepage__reviews__bottom_paragraph subtitle_2"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(noWinPageData?.reviewSection?.bottomParagraph) }}
            />
          </section>
        </div>
  )
};

export default NoWinNoFee;
